import { X, ExternalLink } from "lucide-react";
import EditorEmbed, { isGoogleEditable } from "./EditorEmbed";
import ReadOnlyPreview from "./ReadOnlyPreview";

export default function PreviewPane({ file, onClose }) {
  if (!file) return null;

  const editable = isGoogleEditable(file.mimeType);

  return (
    <div className="flex flex-col h-full bg-white border-l">
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <div className="font-semibold truncate">{file.name}</div>
        <div className="flex items-center gap-2">
          <a
            href={file.webViewLink}
            target="_blank"
            rel="noreferrer"
            className="text-sm text-linkColor hover:underline flex items-center gap-1"
          >
            <ExternalLink className="w-4 h-4" /> Open in Drive {editable ? "to edit" : ""}
          </a>
          <button onClick={onClose} aria-label="Close preview" className="p-1 hover:bg-gray-100 rounded">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex-1 min-h-0">
        {editable ? <EditorEmbed file={file} /> : <ReadOnlyPreview file={file} />}
      </div>
    </div>
  );
}
